export default __webpack_public_path__ + "static/media/Learning-bro.af605e66.svg";